"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ArrowLeftTray: function() {
        return ArrowLeftTray;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const ArrowLeftTray = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M22 5C22 3.34315 20.6569 2 19 2H12C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4H19C19.5523 4 20 4.44772 20 5V19C20 19.5523 19.5523 20 19 20H12C11.4477 20 11 20.4477 11 21C11 21.5523 11.4477 22 12 22H19C20.6569 22 22 20.6569 22 19V5ZM7.7071 7.29289C7.31658 6.90237 6.68341 6.90237 6.29289 7.29289L2.29289 11.2929C2.09687 11.4889 1.99924 11.7461 2 12.003C2 12.0033 2 12.0036 2 12.0039C2.00008 12.3057 2.13386 12.5762 2.34532 12.7595L6.29289 16.7071C6.68341 17.0976 7.31658 17.0976 7.7071 16.7071C8.09763 16.3166 8.09763 15.6834 7.7071 15.2929L5.41715 13.0029L16.0003 13C16.5526 12.9998 17.0001 12.552 17 11.9997C16.9998 11.4474 16.552 10.9998 15.9997 11L5.41127 11.0029L7.7071 8.70711C8.09763 8.31658 8.09763 7.68342 7.7071 7.29289Z",
        fill: "currentColor"
    })
}), "ArrowLeftTray");
const _default = ArrowLeftTray;
